export default "Puissances par classe temporelle, énergie réactive, dépassements : audit TURPE de votre site industriel à partir des courbes de charge. Économies récurrentes, sans toucher au process.";
